import { NotificationService, CONSTANT, LoaderService, ErrorService, EVENTO, TOOLTIPS, ICONS, ACTIONS } from "../../../../shared/session/index";
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { CustomValidators, RegularExpression, RegularExpressionMessage } from '../../../../shared/validation/customvalidation';
import { Iempresa, Empresa } from "../shared/empresa.model";
import { EmpresaService } from "../shared/empresa.service";


@Component({
    selector: 'app-empresa-new',
    templateUrl: 'empresa-new.component.html'
})
export class EmpresaNewComponent implements OnInit {
    @Output() onChangeEvent: EventEmitter<any> = new EventEmitter();
    @Input() data: any;
    @Input() titlePage: string;
    @Input() ID: number;

    formGroupNewEmpresa: FormGroup;
    msgSuccessInsert: string;
    msgErrorInsert: string;
    obligatorioMsg: string;
    empresa: Iempresa;
    maxLengthMsg: string;
    empresaName: string;
    buttonGroup: any;
    rucMaxLength: number;
    dniMaxLength: number = 8;

    constructor(public fb: FormBuilder,
        private loaderService: LoaderService,
        private empresaService: EmpresaService,
        private notificationService: NotificationService) { }

    ngOnInit() {
        this.empresa = new Empresa(0, "", "", "", "", "", "", true, "", "", "", "", "", null, "");
        this.msgSuccessInsert = 'Se registró satisfactoriamente';
        this.msgErrorInsert = 'Error al registrar la oficina';
        this.titlePage = 'Completa los datos de la oficina';
        this.obligatorioMsg = 'Campo Obligatorio';
        this.rucMaxLength = 11;
        this.maxLengthMsg = 'El tamaño máximo es de ';
        this.buttonGroup = [
            { tooltip: TOOLTIPS.save, icon: ICONS.save, action: ACTIONS.save }
        ];

        this.setValuesFormBuilder();
    }

    private setValuesFormBuilder() {
        this.formGroupNewEmpresa = this.fb.group({
            Name: ['', Validators.compose([Validators.required])],
            Direccion: ['', Validators.compose([Validators.required])],
            RUC: ['', Validators.compose([Validators.required])],
            razonSocial: ['', Validators.compose([Validators.required])],
            Agent: ['', Validators.compose([Validators.required])],
            documento: ['', Validators.compose([Validators.required])],
            nombreCorto: ['', Validators.compose([Validators.required])],
        });
    }

    changeEvent(empresa: Iempresa) {
        this.data.empresa = { ID: empresa.ID, Name: empresa.Name };
        this.onChangeEvent.emit({ evento: EVENTO.consultar, data: this.data });
    }
    formGroupNewEmpresaSubmit(event) {
        if (this.formGroupNewEmpresa.invalid)
            return;
        this.empresa.Name = event.value.Name;
        this.empresa.Direccion = event.value.Direccion;
        this.empresa.RUC = event.value.RUC;
        this.empresa.RazonSocial = event.value.razonSocial;
        this.empresa.Agent = event.value.Agent;
        this.empresa.Dni = event.value.documento;
        this.empresa.nombreCorto = event.value.nombreCorto;
        this.insertarEmpresa(this.empresa);
    }

    private insertarEmpresa(empresa: Iempresa) {
        this.loaderService.show();
        this.empresaService.insertarEmpresa(empresa)
            .subscribe(res => {
                empresa.ID = res;
                this.changeEvent(empresa);
                this.notificationService.successful("Se grabo satisfactoriamente");
            },
                error => {
                    this.notificationService.error(this.msgErrorInsert);
                    throw error;
                },
                () => {
                    this.loaderService.hide();
                });
    }

    public onlyDecimalNumberKey(event, value) {
        let charCode = (event.which) ? event.which : event.keyCode;
        if (charCode == 46 && String(value).indexOf('.') > 0)
            return false;

        if (charCode != 46 && charCode > 31 && (charCode < 48 || charCode > 57))
            return false;
        return true;
    }


}
